import { Currency, Lookup } from "src/app/models/Lookup"

export enum OrderDiscountType {
  Manual = 'Manual',
  HappyHour = 'HappyHour',
  PromoCode = 'PromoCode',
  RestaurantVoucherLoyalityPoints = 'RestaurantVoucherLoyalityPoints',
  RestaurantVoucherCode = 'RestaurantVoucherCode'
}
export enum ValueTypeEnum {
  Percentage = 'Percentage',
  Value = 'Value'
}
export enum CheckOutType {
  Total = 'Total',
  SplitPrice = 'SplitPrice',
  SplitItem = 'SplitItem'
}
export class CheckOutDetails {
  orderId!: number
  cashOptions!: number[]
  currency!: Currency
  discountName!: string
  discountValue!: number
  serviceValue!: number
  surchargeValue!: number
  subTotal!: number
  taxValue!: number
  total!: number
  paid!: number
  toBePaid!: number
  partySize!: number

  hasCashOption!: boolean
  paymentDetails!: PaymentDetails[]
  paymentOptions!: Lookup[]
  canManageDiscount!: boolean
  canManageSurcharge!: boolean
  canPaymentDetails!: boolean
  canItemSplit!: boolean
  isTotalyPaid!: boolean

  splitItemList!: any
  splitPriceList!: SplitByPrice[]
  onlinePaymentPaid!: CheckOutResult

  isClosed!: boolean
  closeDate!: Date
  closedBy!: {
    id?: number
    name?: string
    profilePic?: string
  }
  otherPaymentOptions!: Lookup[]
}
export class PaymentDetails {
  checkOutId!: number
  canAddTip!: boolean
  checkOutType!: CheckOutType
  paidPrice!: number
  paymentOption!: string
  priceAmount!: number
  remainAmount!: number
  reservationOrderSelectedItems!: CheckOutSplitItemsList[]
  tipsValue!: number
}
export class CheckOutSplitItemsList {
  itemName!: string
  itemPic!: string
  sizeName!: string
  priceAmount!: number
  itemPrice!: number
  shareDiscountValue!: number
  shareTaxValue!: number
  shareServiceValue!: number
  shareSurchargeValue!: number
  otherDiscount!: number
  quantity!: number
}
export class CheckOutModel {
  orderId!: number
  checkOutType!: CheckOutType
  paidAmount!: number
  paymentOptionsId!: number
  splitPriceList!: SplitByPrice[]
  splitItemList!: CheckOutSplitItemList[]

  paymentType?: string
  paymentOptionsCode?: string
  CheckOutRedirectUrl?: string

  otherPaymentOptionsId?: number
  otherPaymentOptionsComment?: string

  paymentSourceType!: PaymentSourceTypeEnum;
  deviceId!: any
  deviceType!: any
}
export class CheckOutSplitItemList {
  reservationMenuItemId!: number
  splitQuantity!: number
}
export class SplitByPrice {
  checkOutId!: number
  paidAmount!: number
  priceAmount!: number
  isPaid!: boolean
  payNow!: boolean
  isValid!: boolean
}
export class CheckOutResult {
  result!: any
  hasTips!: boolean
  tipValue!: number
  orderId!: number
  orderNumber!: number
  checkOutId!: number
  currency!: Currency
  isTotalyPaid!: boolean
  canPrint!: boolean
  kitchens!: Lookup[]
}

export enum PaymentSourceTypeEnum {
  ClientQrCode = 'ClientQrCode',
  System = 'System'
}
